import { SkeletonItem } from '../models/dashboard-models';
import { HandoverItem, ShortDevicePassport } from '../models/warehouse-models';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useAsyncResource } from 'use-async-resource';
import { useGetVatPrefix } from './configuration-hooks';

export const constructHandoverItems = (items: SkeletonItem[], passports: ShortDevicePassport[]) => {
    return items.map((item) => {
        const neededPassport = passports.find((el) => el.id === item.itemId);
        if (neededPassport && neededPassport.id) {
            return {
                itemId: neededPassport.id,
                itemName: neededPassport.name,
                itemCount: item.count,
                itemType: 'DEVICE',
                cost: 0,
                oilName: '',
                oilQuantity: 0,
            } as HandoverItem;
        } else {
            return {} as HandoverItem;
        }
    });
};

export const useGetClientPrefix = (clientPrefix: string | undefined) => {
    const {group} = useContext(AuthContext);
    const [getVatPrefix] = useAsyncResource(useGetVatPrefix, group);
    const vatPrefix = getVatPrefix();
    const clientVatPrefix = clientPrefix ? clientPrefix : vatPrefix.prefix;
    return clientVatPrefix;
}

export function useDebounce<T>(value: T, delay: number): T {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => clearTimeout(timer);
    }, [value, delay]);

    return debouncedValue;
}
